import i18n, { use, changeLanguage } from 'i18next';
import { initReactI18next } from 'react-i18next';
import log from 'loglevel';
import translations from '../langs/langs';

class Translation {
  private static instance: Translation;

  private constructor() {
    if (!i18n.isInitialized) {
      use(initReactI18next).init({
        debug: true,
        interpolation: {
          escapeValue: false,
        },
      });
    }
  }

  public static getInstance(): Translation {
    if (!Translation.instance) {
      Translation.instance = new Translation();
    }
    return Translation.instance;
  }

  loadTranslations(lang: string) {
    if (translations[lang]) return translations[lang];
    return {};
  }

  async load(lang: string, lang_keys: any, fallback: string) {
    if (i18n.language === lang) {
      return;
    }
    if (fallback) i18n.options.fallbackLng = fallback;
    try {
      const mainTranslation = this.loadTranslations(lang);
      const fallbackTranslation = this.loadTranslations(fallback);

      if(typeof lang_keys !== 'object') 
        lang_keys = {};

      let keysDefinedInInitOptions = lang_keys[lang] || {};

      const jsonDataMerge = {
        ...fallbackTranslation,
        ...mainTranslation,
        ...keysDefinedInInitOptions,
      };

      i18n.addResourceBundle(lang, 'translation', jsonDataMerge);
      await changeLanguage(lang);
    } catch (error) {
      log.debug('Error loading translations', error);
    }
  }
}

export default Translation;
